import {call, put} from 'redux-saga/effects';
import {httpPost} from '../../util/Rest';
import {ACCOUNTSUMMARY} from '../../constants/MicroServiceConstants';
import {fetchSearchData, fetchError} from '../reducers/search';
function httpsPostwithobj(obj) {
  return httpPost(obj.url, obj.body);
}
export default function* SearchHandler(action) {
  try {
    const response = yield call(httpsPostwithobj, {
      url: `${ACCOUNTSUMMARY}/find/all`,
      body: action.payload,
    });
    if ((response && response.status >= 500) || (response && response.status >= 400)) {
      yield put(fetchError(response?.data?.error ? response.data.error : response.data));
    } else {
      yield put(fetchSearchData(response?.response));
    }
  } catch (error) {
    yield put(fetchError(error.message));
  }
}
